/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_LabelInputs */



/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Manual_Qc_Priority_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_label = /** @type {((inputs?: Manual_Qc_Priority_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Priorite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Priorität")
	if (locale === "it") return /** @type {LocalizedString} */ ("Priorità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приоритет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Prioridad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("优先事项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("優先度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राथमिकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prioridade")
	return /** @type {LocalizedString} */ ("Priority")
});